<template>
  <div v-loading="loading">
    <!-- 投保单订单详情 -->
    <headBox title="订单详情" :showBack="true"></headBox>
    <div class="tbd-content">
      <div class="tb-card">
        <div class="card-head clearfix">
          <div class="title1">
            当前订单
            <div class="order-desc">
              {{ detailList | filterOrderStatus(all) }}
            </div>
          </div>
          <div class="title2" v-if="userinfo.level != 3 && mechanName">
            <div v-if="['1', '2'].includes(mechanLevel)">
              <tooltip class="val-right" :txt-info="`出单团队：${mechanName}`"></tooltip>
            </div>
            <div v-else>
              <tooltip class="val-right" :txt-info="`出单员工：${mechanName}`"></tooltip>
            </div>
          </div>
        </div>
        <div class="card-body clearfix">
          <div class="card-left">
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">订单号</div>
                <tooltip class="val-right" :txt-info="detailList.orderId | filterNull"></tooltip>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">投保产品</div>
                <tooltip class="val-right" :txt-info="detailList.productName | filterNull"></tooltip>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">微信昵称</div>
                <!-- <div class="val-right">
                  {{ detailList.nickname | filterNull }}
                </div> -->
                <tooltip class="val-right" :txt-info="detailList.nickname | filterNull"></tooltip>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">支付金额</div>
                <div class="val-right">{{ detailList.orderFee | filterNull }}元</div>
              </div>
            </div>
            <div class="card-row" v-if="detailList.payStatus == undefined || detailList.payStatus == 0">
              <div class="card-cell">
                <div class="lab-left">核保状态</div>
                <div class="val-right" v-if="auditOrder == '1'">
                  {{ detailList.orderStatus | filterHbStatus }}<span v-if="detailList.orderStatus && detailList.manualStatus">-</span
                  >{{ detailList.manualStatus }}
                </div>
                <div class="val-right" v-if="auditOrder != '1'">
                  {{ detailList.orderStatus | filterHbStatus }}<span v-if="detailList.orderStatus && detailList.manualStatus">-</span
                  >{{ detailList.manualStatus }}
                </div>
              </div>
            </div>
            <div class="card-row" v-if="['4', '6'].includes(detailList.orderStatus)">
              <div class="card-cell">
                <div class="lab-left">失败原因</div>
                <div class="val-right" v-show="!detailList.manualFailReason || detailList.manualFailReason.length < 10">
                  {{ detailList.manualFailReason | filterNull }}
                </div>
                <el-tooltip class="item" effect="dark" :content="detailList.manualFailReason" placement="top">
                  <div class="val-right" v-show="detailList.manualFailReason && detailList.manualFailReason.length >= 10">
                    {{ detailList.manualFailReason ? detailList.manualFailReason.substr(0, 10) : '-' }}
                    <span>...</span>
                  </div>
                </el-tooltip>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">最后回执回访时间</div>
                <div class="val-right">
                  {{ detailList.lastRevisitTime | timeSplit }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">回执回访状态</div>
                <div class="val-right">
                  {{ detailList.receiptRevisitStatus | filterVisit2 }}
                  <!-- {{
                    all.RETURN_VISIT_STATUS[detailList.returnVisitStatus]
                      | filterNull
                  }} -->
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">犹豫到期</div>
                <div class="val-right">{{ detailList.waverLimitDate }}</div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">退款时间</div>
                <div class="val-right">
                  {{ detailList.refundTime | timeSplit }}
                </div>
              </div>
            </div>
            <div class="card-row">
              <div class="card-cell">
                <div class="lab-left">双录状态</div>
                <tooltip class="val-right" :txt-info="all.DOUBLE_RECORD_STATUS[detailList.doubleRecordStatus]"></tooltip>
              </div>
            </div>
            <div class="card-row" v-if="detailList.confirmRightStatus">
              <div class="card-cell">
                <div class="lab-left">质检状态</div>
                <tooltip class="val-right" :txt-info="all.CONFIRM_RIGHT_STATUS[detailList.confirmRightStatus]"></tooltip>
              </div>
            </div>
            <!-- 质检失败显示 -->
            <div class="card-row" v-if="detailList.confirmRightStatus == -1">
              <div class="card-cell">
                <div class="lab-left">质检不通过原因</div>
                <tooltip class="val-right" :txt-info="detailList.confirmRightRemark"></tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="tb-info">
        <el-tabs v-model="activeName">
          <el-tab-pane label="投保信息" name="first">
            <div class="tb-info-card">
              <div class="tb-info-title">保障信息</div>
              <div class="card-body card-body-padding">
                <div class="info-row" v-if="detailList.policyType == 1">
                  <div class="info-lab">保单类型</div>
                  <div class="info-val">
                    {{ detailList.oldPolicyNo ? '续保单' : '新单' }}
                  </div>
                </div>
                <div class="info-row" v-if="detailList.oldPolicyNo">
                  <div class="info-lab">原保单号</div>
                  <div class="info-val">
                    {{ detailList.oldPolicyNo }}
                  </div>
                </div>
                <div class="info-row" v-if="tbPolicyNo">
                  <div class="info-lab">保单号</div>
                  <div class="info-val">
                    <tooltip :txt-info="detailList.policyNo | filterNull"></tooltip>
                  </div>
                </div>
                <div class="info-row" v-if="tbPolicyNo">
                  <div class="info-lab">保单状态</div>
                  <div class="info-val">
                    {{ all.POLICY_STATUS[detailList.policyStatus] || '-' }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">总保费</div>
                  <div class="info-val">{{ detailList.fee | filterNull }}元</div>
                </div>
                <div class="info-row">
                  <div class="info-lab">交费方式</div>
                  <div class="info-val">
                    {{ detailList.payType | filterPayType }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">交费期限</div>
                  <div class="info-val" v-if="detailList.payment == 4 || detailList.payment == 5">
                    {{ detailList.payment | filterPayment }}
                  </div>
                  <div class="info-val" v-else>{{ detailList.payPerm }}{{ all.PAYMENT_TYPE[detailList.payment] | filterNull }}</div>
                </div>
                <div class="info-row">
                  <div class="info-lab">保障额度</div>
                  <div class="info-val">
                    {{ detailList.totalInsured | filterNull }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">保障期限</div>
                  <div class="info-val">
                    <span v-if="detailList.guarateeLimit != 106">{{ detailList.guarateeLimit }}</span>
                    <span>{{ detailList.guarateeType | guarateeType }}</span>
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">起保日期</div>
                  <div class="info-val">
                    {{ detailList.startTime | timeSplit }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">终保日期</div>
                  <div class="info-val">
                    {{ detailList.endTime | timeSplit }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">是否含身故</div>
                  <div class="info-val" v-if="detailList.includingDeath == '0'">不含身故</div>
                  <div class="info-val" v-else-if="detailList.includingDeath == '1'">含身故</div>
                  <div class="info-val" v-else>-</div>
                </div>
              </div>
            </div>

            <div class="tb-info-card">
              <div class="tb-info-title">投保人信息</div>
              <div class="card-body card-body-padding">
                <div class="info-row">
                  <div class="info-lab">姓名</div>
                  <div class="info-val">
                    {{ detailList.policyerName | filterNull }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">性别</div>
                  <div class="info-val">
                    {{ detailList.holderSex == '1' ? '男' : detailList.holderSex == '2' ? '女' : '-' }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">出生日期</div>
                  <div class="info-val">
                    {{ detailList.holderBirthday | timeSplit }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">证件类型</div>
                  <div class="info-val">
                    {{ all.CARD_TYPE[detailList.policyerCardType] || '-' }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">证件号码</div>
                  <div
                    class="info-val"
                    :class="{ 'can-click': detailList.isDecrypt && detailList.policyerIdCard }"
                    @dblclick="
                      detailList.policyerIdCard && detailList.isDecrypt && descrypt(2, 1, detailList.policyerIdCardMd5, orderNo, 'policyerIdCard', detailList)
                    "
                  >
                    {{ detailList.policyerIdCard | filterNull }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">手机号码</div>
                  <div
                    class="info-val"
                    :class="{ 'can-click': detailList.isDecrypt && detailList.policyerMobile }"
                    @dblclick="
                      detailList.policyerMobile && detailList.isDecrypt && descrypt(2, 2, detailList.policyerMobileMd5, orderNo, 'policyerMobile', detailList)
                    "
                  >
                    {{ detailList.policyerMobile | filterNull }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">电子邮箱</div>
                  <div
                    class="info-val"
                    :class="{ 'can-click': detailList.isDecrypt && detailList.holderEmail }"
                    @dblclick="detailList.holderEmail && detailList.isDecrypt && descrypt(2, 9, detailList.holderEmailMd5, orderNo, 'holderEmail', detailList)"
                  >
                    {{ detailList.holderEmail | filterNull }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">所在地区</div>
                  <tooltip class="info-val" :txt-info="detailList.holderArea | holderArea"></tooltip>
                </div>
                <div class="info-row mt" style="width: 100%">
                  <div class="info-lab">详细地址</div>
                  <div
                    class="info-val"
                    :class="{ 'can-click': detailList.isDecrypt && detailList.holderHomeAddress }"
                    @dblclick="
                      detailList.holderHomeAddress &&
                        detailList.isDecrypt &&
                        descrypt(2, 8, detailList.holderHomeAddressMd5, orderNo, 'holderHomeAddress', detailList)
                    "
                  >
                    {{ detailList.holderHomeAddress | holderHomeAddress }}
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>

          <el-tab-pane label="被保险人及权益" name="second">
            <div class="tb-info-card">
              <div class="tb-info-title">被保险人</div>
              <template v-if="insuredersJson.length != 0">
                <div class="card-body bbxr-card-body clearfix" v-for="(bean, i) in insuredersJson" :key="i">
                  <div class="triangle-topleft">
                    <span>{{ i + 1 }}</span>
                  </div>
                  <div class="info-box">
                    <div class="info-row">
                      <div class="info-lab">姓名</div>
                      <div class="info-val">
                        {{ bean.insurederName | filterNull }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-lab">性别</div>
                      <div class="info-val">
                        {{ bean.insurederSex == '1' ? '男' : bean.insurederSex == '2' ? '女' : '-' }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-lab">出生日期</div>
                      <div class="info-val">
                        {{ bean.insurederBirthday | timeSplit }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-lab">证件号码</div>
                      <div
                        class="info-val"
                        :class="{ 'can-click': detailList.isDecrypt && bean.insurederIdCardMask }"
                        @dblclick="
                          bean.insurederIdCardMask && detailList.isDecrypt && descrypt(2, 1, bean.insurederIdCardMd5, orderNo, 'insurederIdCardMask', bean)
                        "
                      >
                        {{ bean.insurederIdCardMask | filterNull }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-lab">手机号码</div>
                      <div
                        class="info-val"
                        :class="{ 'can-click': detailList.isDecrypt && bean.insuranceMobile }"
                        @dblclick="bean.insuranceMobile && detailList.isDecrypt && descrypt(2, 2, bean.insuranceMobileMd5, orderNo, 'insuranceMobile', bean)"
                      >
                        {{ bean.insuranceMobile | filterNull }}
                      </div>
                    </div>
                    <div class="info-row">
                      <div class="info-lab">与投保人关系</div>
                      <div class="info-val">
                        {{ bean.insuredRelationship | beneRelationship }}
                      </div>
                    </div>
                    <!-- 一个订单多个保单多个被保人显示，多保单时保单号字段在被保人数据里 -->
                    <div v-if="bean.policyNos.length > 1" v-for="(policy, policyIdx) in bean.policyNos" :key="policy" class="info-row">
                      <div class="info-lab">保单号{{ 1 + policyIdx }}</div>
                      <div class="info-val">
                        <div>
                          {{ policy
                          }}<span :class="bean.policyStatus[policyIdx] == 1 ? 'status-label1' : 'status-label2'">{{
                            all.POLICY_STATUS[bean.policyStatus[policyIdx]] || '-'
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="ckqy-content">
                    <el-button class="ckqy-btn" type="text" @click="getGarmteeDetail(bean.insurederIdCard, bean.insurederIdCardMd5)">查看权益</el-button>
                    <i class="el-icon-arrow-right"></i>
                    <template v-if="bean.policyNo && !dzbdHide">
                      <br />
                      <br />
                      <el-dropdown v-if="bean.policyNos.length > 1" @command="policy => downloadPolicy(policy)">
                        <span class="el-dropdown-link"> 电子保单<i class="el-icon-arrow-down el-icon--right"></i> </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item v-for="(policy, pidx) in bean.policyNos" :key="policy" :command="policy">电子保单{{ pidx + 1 }}</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                      <el-button v-if="bean.policyNos.length == 1" class="ckqy-btn" type="text" @click="downloadPolicy(bean.policyNo)">电子保单</el-button>
                    </template>
                  </div>
                  <el-dialog title="权益详情" :visible.sync="dialogTableVisible" width="565px" custom-class="xq-dialog">
                    <el-table :data="garmtee" :header-cell-style="returnStyle" border style="width: 100%">
                      <el-table-column property="premiseAttribute" label="保障项目" align="center"></el-table-column>
                      <el-table-column property="guaranteeMoney" label="保额/详情" align="center"></el-table-column>
                      <emptyBox slot="empty"></emptyBox>
                    </el-table>
                  </el-dialog>
                </div>
              </template>
              <div class="card-body bbxr-card-body clearfix" v-else>
                <div class="triangle-topleft">
                  <span>{{ 1 }}</span>
                </div>
                <div class="info-box">
                  <div class="info-row">
                    <div class="info-lab">姓名</div>
                    <div class="info-val">{{ '-' }}</div>
                  </div>
                  <div class="info-row">
                    <div class="info-lab">性别</div>
                    <div class="info-val">
                      {{ '-' }}
                    </div>
                  </div>
                  <div class="info-row">
                    <div class="info-lab">出生日期</div>
                    <div class="info-val">
                      {{ '-' }}
                    </div>
                  </div>
                  <div class="info-row">
                    <div class="info-lab">证件号码</div>
                    <div class="info-val">{{ '-' }}</div>
                  </div>
                  <div class="info-row">
                    <div class="info-lab">与投保人关系</div>
                    <div class="info-val">
                      {{ '-' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="tb-info-card">
              <div class="tb-info-title">受益人</div>
              <div class="tb-info-title1">
                受益人类型：
                <span class="val-info" v-if="detailList.beneficiaryType == '1'">法定受益人</span>
                <span class="val-info" v-if="detailList.beneficiaryType == '2'">指定受益人</span>
                <span class="val-info" v-if="detailList.beneficiaryType == '3'">被保险人</span>
              </div>
              <div class="table-box" v-if="detailList.beneficiaryType == '2'">
                <div class="table-content">
                  <div class="table-row first">
                    <div class="table-col">姓名</div>
                    <div class="table-col">证件号码</div>
                    <div class="table-col">与被保险人关系</div>
                    <div class="table-col">收益比例</div>
                  </div>
                  <div class="table-row" v-for="(item, index) in beneInfo" :key="index">
                    <div class="table-col">
                      {{ item.beneName | filterNull }}
                    </div>
                    <div
                      class="table-col"
                      :class="{ 'can-click': detailList.isDecrypt && item.beneIdCard }"
                      @dblclick="item.beneIdCard && detailList.isDecrypt && descrypt(2, 1, item.beneIdCardMd5, orderNo, 'beneIdCard', item)"
                    >
                      {{ item.beneIdCard | filterNull }}
                    </div>
                    <div class="table-col">
                      {{ item.beneRelationship | beneRelationship }}
                    </div>
                    <div class="table-col">
                      {{ item.beneRate | filterNull }}
                    </div>
                  </div>
                  <div class="table-row" v-if="beneInfo.length == 0">
                    <div class="table-col" v-for="(t, n) in 4" :key="n">
                      {{ '-' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <!-- renewalType为null默认显示续期信息 -->
          <!-- 多保单的时候没有保单号，判断下续期信息 -->
          <el-tab-pane label="续期信息" name="third" v-if="(detailList.policyNo || renewalRecordGroup.length > 0) && this.checkAuth('renewalList')">
            <div class="tb-info-card">
              <div class="tb-info-title">银行卡信息</div>
              <div class="card-body card-body-padding">
                <div class="info-row">
                  <div class="info-lab">银行卡号</div>
                  <div
                    class="info-val"
                    :class="{ 'can-click': detailList.isDecrypt && detailList.accountNumber }"
                    @dblclick="detailList.accountNumber && detailList.isDecrypt && descrypt(2, 3, detailList.accountNumberMd5, orderNo, 'accountNumber', detailList)"
                  >
                    {{ detailList.accountNumber | filterNull }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">持卡人</div>
                  <div class="info-val">
                    {{ detailList.policyerName | filterNull }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">开户行</div>
                  <div class="info-val">
                    {{ detailList.accountBank | filterNull }}
                  </div>
                </div>
                <div class="info-row">
                  <div class="info-lab">续期周期</div>
                  <div class="info-val">
                    {{ detailList.payType | filterPayType }}
                  </div>
                </div>
              </div>
            </div>
            <div class="tb-info-card">
              <!-- renewalType==1续保信息。2续期信息。null续期信息，默认为续期信息 -->
              <div class="tb-info-title">
                续期信息
                <!-- <span> (仅显示有服务费的期数)</span> -->
              </div>
              <template v-for="(renewalList, n) in renewalRecordGroup">
                <div class="table-top" :key="n">
                  <div class="tb-info-title1" v-if="renewalRecordGroup.length > 1">
                    保单号：<span class="val-info">{{ renewalList.policyNo }}</span>
                  </div>
                  <el-table :data="renewalList.data" border style="width: 100%; margin-bottom: 15px">
                    <el-table-column align="center" prop="payNum" label="期数" width="100px"> </el-table-column>
                    <el-table-column align="center" prop="renewalType" label="类型" width="100px">
                      <template slot-scope="scope">
                        <div>
                          <!-- renewalType==1 续保，2续费。其他值显示为空'-' -->
                          {{ scope.row.renewalType | filterRenewalType }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="needPayTime" label="应交费日期">
                      <template slot-scope="scope">
                        {{ scope.row.needPayTime | timeSplit }}
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="lastPayTime" label="宽限期满日期" v-if="detailList.renewalType != 1">
                      <template slot-scope="scope">
                        {{ scope.row.lastPayTime | timeSplit }}
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="fee" label="应交保费（元）"> </el-table-column>
                    <el-table-column align="center" prop="renewalStatus" label="状态">
                      <template slot-scope="scope">
                        <div>
                          {{ scope.row | renewalStatus }}
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="payTime" label="实际交费日期">
                      <template slot-scope="scope">
                        <!-- 续费成功显示 -->
                        <span v-if="scope.row.renewalStatus == 2">{{ scope.row.payTime | timeSplit }}</span>
                        <span v-else>-</span>
                      </template>
                    </el-table-column>
                    <el-table-column align="center" prop="payFee" label="实交保费（元）">
                      <template slot-scope="scope">
                        {{ scope.row.payFee | filterNull }}
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </template>
              <!-- 处理空数据 -->
              <template v-if="renewalRecordGroup.length == 0">
                <div>
                  <el-table border style="width: 100%">
                    <el-table-column align="center" label="期数"> </el-table-column>
                    <el-table-column align="center" label="类型"> </el-table-column>
                    <el-table-column align="center" label="应交费日期"> </el-table-column>
                    <el-table-column align="center" label="宽限期满日期" v-if="detailList.renewalType != 1"> </el-table-column>
                    <el-table-column align="center" label="应交保费（元）"> </el-table-column>
                    <el-table-column align="center" label="状态"> </el-table-column>
                    <el-table-column align="center" label="实际交费日期"> </el-table-column>
                    <el-table-column align="center" label="实交保费（元）"> </el-table-column>
                    <emptyBox slot="empty"></emptyBox>
                  </el-table>
                </div>
              </template>
            </div>
          </el-tab-pane>
          <!-- 服务费信息 -->
          <el-tab-pane label="服务费信息" name="fourth" v-if="checkAuth('orderCommission')">
            <commissonsDetail :orderNo="orderNo" :payType="detailList.payType"></commissonsDetail>
          </el-tab-pane>
          <!-- 加保记录 -->
          <el-tab-pane label="加保记录" name="addPolicy" v-if="detailList.addPolicy && detailList.cashValueJump">
            <addPolicyList :policyNo="tbPolicyNo"></addPolicyList>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <helpTool type="orderDetail"></helpTool>
  </div>
</template>
<script>
import helpTool from '@/components/helpTool.vue';
import tooltip from '@/components/tooltip';
import headBox from '@/components/head.vue';
import commissonsDetail from './components/commissonsDetail.vue';
import addPolicyList from './components/addPolicyList.vue';
import { common } from '@/api/mixins';
export default {
  mixins: [common],
  data: () => ({
    //renewalType：保单类型，1续保 2 续费
    renewalRecordGroup: [], //续期信息分组
    mechanChildShortName: '', //下级团队
    mechanName: '', // 团队简称
    orderId: '', // 订单号
    orderNo: '', // 订单号
    detailList: '', // 订单详情列表
    all: {}, // 字典
    beneInfo: [], //受益人信息
    allgarmtee: [], // 全部权益
    garmtee: [], //当前被保人保障权益
    insuredersJson: [], //被保人信息
    renewalRecord: [], // 续期记录
    commissons: [], // 保单费用
    dialogTableVisible: false,
    activeName: 'first',
    manualList: [], // 人核进度列表
    auditOrder: '', // 是否是人核单
    tbPolicyNo: '', // 保单号
    spanArr: [],
    position: '',
    // employee:true,//是否显示服务费字段,true显示，false不显示
    loading: true,
    moreBtnShow: false,
    dzbdHide: false, //电子保单隐藏
    userinfo: {}
  }),
  created() {
    this.$tools.getall(data => {
      this.all = data;
    });
    this.getPageInfo();
    this.getUserInfo();
  },
  components: {
    addPolicyList,
    commissonsDetail,
    helpTool,
    tooltip,
    headBox
  },
  methods: {
    getUserInfo() {
      const data = this.$tools.getLocal('userinfo');
      this.userinfo = data;
      if (data.level == 3) {
        const hideCode = ['bz0211025039', 'bz0191018029']; //bz0191018029测试的code
        if (hideCode.includes(data.parentMechanCode)) {
          //特殊处理泰康在线员工 隐藏电子保单
          this.dzbdHide = true;
        }
      }
      // 判断是否有电子保单权限
      if (!this.checkAuth('policyDownload')) {
        this.dzbdHide = true;
      }
    },
    //下载电子保单
    downloadPolicy: function(id) {
      this.$http({
        url: '/master/policy/downloadPolicy',
        type: 'post',
        params: {
          policyNo: id
        }
      }).then(function(data) {
        window.open(data.data);
      });
    },
    // 匹配投保人对应的权益
    getGarmteeDetail(idCard, cardMd5) {
      if (this.insuredersJson.length > 1) {
        this.garmtee = this.allgarmtee.filter(item => {
          if (item.insuresCardNo) {
            if (item.insuresCardNo == idCard) {
              return item;
            } else if (item.insuresCardNo == cardMd5) {
              return item;
            }
          }
        });
      } else {
        this.garmtee = this.allgarmtee;
      }
      this.dialogTableVisible = true;
    },

    returnStyle() {
      return { background: '#F7F7F7', 'text-align': 'center' };
    },
    // 页面模块信息
    getPageInfo() {
      this.auditOrder = this.$route.query.auditOrder;
      this.tbPolicyNo = this.$route.query.policyNo;
      this.orderId = this.$route.query.orderId;
      this.mechanName = this.$route.query.mechanShortName;
      this.mechanLevel = this.$route.query.mechanLevel;
      this.getOrderDetail();
    },

    // 获取订单详情
    getOrderDetail() {
      this.$http({
        url: '/master/order/queryOrderDetail',
        type: 'put',
        params: {
          orderId: this.orderId
        }
      }).then(res => {
        this.loading = false;
        this.detailList = res.data;
        if (!res.data.isDownLoadPolicy) {
          this.dzbdHide = true;
        }
        if (res.data.insuredersJson) {
          this.insuredersJson = JSON.parse(res.data.insuredersJson).map(i => {
            i.policyNos = i.policyNo ? i.policyNo.split(',') : '';
            i.policyStatus = i.policyStatus ? i.policyStatus.toString().split(',') : '';
            return i;
          });
        }
        if (res.data.garmtee) {
          this.allgarmtee = JSON.parse(res.data.garmtee);
        }
        if (this.detailList.beneInfo) {
          this.beneInfo = JSON.parse(this.detailList.beneInfo);
        }
        this.getRenewalRecord(res.data.orderNo);
        this.orderNo = res.data.orderNo;
      });
    },
    // 获取续期记录
    getRenewalRecord(val) {
      if (!this.checkAuth('renewalList')) {
        return;
      }
      this.$http({
        url: '/master/policy/queryRenewalRecord',
        type: 'put',
        params: {
          orderNo: val
        }
      }).then(res => {
        this.renewalRecord = res.data;
        let map = {},
          dest = [];
        //保单分组
        for (let i = 0, len = this.renewalRecord.length; i < len; i++) {
          let ai = this.renewalRecord[i];
          if (!map[ai.policyNo]) {
            dest.push({
              policyNo: ai.policyNo,
              data: [ai]
            });
            map[ai.policyNo] = ai;
          } else {
            for (let j = 0; j < dest.length; j++) {
              let dj = dest[j];
              if (dj.policyNo == ai.policyNo) {
                dj.data.push(ai);
                break;
              }
            }
          }
        }
        this.renewalRecordGroup = dest;
      });
    }
  },
  filters: {
    filterNull(val) {
      if (val == '' || val == null) {
        return '-';
      } else if (val == '111****1111') {
        return '-';
      }
      return val;
    },
    filterRenewalType(val) {
      if (val == '' || val == null) {
        return '-';
      } else if (val == 1) {
        return '续保';
      } else if (val == 2) {
        return '续费';
      }
    },
    renewalStatus(val) {
      let str = '';
      if (val.renewalStatus == 1) {
        str = '待续费';
        return str;
      } else if (val.renewalStatus == 2 && val.payNum == 1) {
        return '已支付';
      } else if (val.renewalStatus == 2) {
        str = '续费成功';
        return str;
      } else if (val.renewalStatus >= 3) {
        str = '续费失败';
        return str;
      }
    },
    //人核状态
    filterHbStatus(val) {
      if (val == '7') {
        return '核保中';
      } else if (val == '1' || val == '2' || val == '3' || val == '5' || val == '9' || val == '-9') {
        return '核保成功';
      } else if (val == '4') {
        return '核保失败';
      } else if (val == '6') {
        return '已失效';
      } else if (val == '8') {
        return '已撤销';
      } else {
        return '-';
      }
    },
    // 交费状态
    payStatus(val) {
      let str = '';
      if (val == '1' || val == '2') {
        str = '待续费';
        return str;
      } else if (val == '3' || val == '4') {
        str = '已支付';
        return str;
      } else if (val === '5') {
        str = '续费成功';
        return str;
      } else if (val === '6') {
        str = '续费失败';
        return str;
      }
    },
    //交费类型
    filterPayment(val) {
      if (val == '4') {
        return '趸交';
      } else if (val == '5') {
        return '终身';
      } else if (val == '6' || val == '1') {
        return '年';
      } else if (val == '2') {
        return '月';
      }
    },
    // 订单状态
    filterOrderStatus(data, all) {
      const val = data.orderStatus;
      if (!val) {
        return '-';
      }
      const payStatus = data.payStatus == 1 ? '已支付' : '未支付';
      if (val == '1') {
        return '未支付';
      } else if (val == '2' || val == '9') {
        return '已支付';
      } else if (val == '3') {
        return '已退款';
      } else if (val == '5' || val == '6') {
        return '已关闭';
      } else if (val == '7') {
        return payStatus + '-' + (data.manualStatus ? data.manualStatus : '人核中');
      } else if (val == '4') {
        return payStatus + '-核保失败';
      } else if (val == '8') {
        return payStatus + '-已撤单';
      } else if (val == '-9') {
        return '未支付-扣款失败';
      } else if (val == '-2') {
        return '承保失败';
      } else {
        return all.ORDER_STATUS[val] || '-';
      }
    },
    filterVisit2(val) {
      if (val == '' || val == null) {
        return '-';
      }
      const map = {
        '-1': '无需回执回访',
        0: '待回执',
        1: '回执失败',
        2: '待回访',
        3: '回访失败',
        4: '审核中',
        5: '回执回访成功'
      };
      return map[val] || '-';
    },
  }
};
</script>
<style lang="scss" scoped>
@import './order_tbd_detail';
</style>
<style lang="scss">
.xq-dialog {
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  letter-spacing: 1px;
  .el-dialog__body {
    padding-top: 10px;
  }
}
</style>
